import React, { useState, useRef } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTableScroll from "../../components/useTableScrollcesar";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";
import { Dimmer } from "../spinner";
import axios from "axios";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import { formatMoneda } from "../../util/varios";
import CatalogoAgenteTipo2 from "../../catalogos/catalogoAgenteTipo2";

export const MinaCaja = (props) => {
  moment.locale("es-us");

  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const anioActu = JSON.parse(localStorage.getItem("anioactu"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));

  const headCells = [
    { label: "#", textAlign: "center" },
    { label: "Tipo", textAlign: "center" },
    { label: "Concepto", textAlign: "center" },
    { label: "Año", textAlign: "center" },
    { label: "Mes", textAlign: "center" },
    { label: "Monto", textAlign: "right" },
    { label: "Intereses Mora", textAlign: "right" },
    { label: "Multas", textAlign: "right" },
    { label: "Recargo", textAlign: "right" },
    { label: "Total", textAlign: "right" },
    { label: "Estatus", textAlign: "center" },
  ];

  const txtAgente = useRef();
  const chkSeleccionarDeuda = useRef([]);
  const chkSeleccionarMulta = useRef([]);
  const chkSeleccionarTasa = useRef([]);

  const [disponiblesMulta, setDisponiblesMulta] = useState(0);
  const [disponiblesTasa, setDisponiblesTasa] = useState(0);
  const [disponiblesDeuda, setDisponiblesDeuda] = useState(0);
  const [catalogo, setCatalogo] = useState(false);
  const [disabledAnio2, setDisabledAnio2] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [deuda, setDeuda] = useState([]);
  const [multa, setMulta] = useState([]);
  const [tasa, setTasa] = useState([]);
  const [disabledDeuda, setDisabledDeuda] = useState(false);
  const [disabledMulta, setDisabledMulta] = useState(false);
  const [disabledTasa, setDisabledTasa] = useState(false);
  const [disabledAnio, setDisabledAnio] = useState(false);
  const [teclas, setTeclas] = useState();
  const [totalSelect, setTotalSelect] = useState({
    concepto: "",
    seleccionados: 0,
    montoseleccionado: 0.0,
    acrediSelect: 0.0,
    montoFacturadoSelect: 0.0,
    interesesSelect: 0.0,
    multaSelect: 0.0,
    recargoSelect: 0.0,
    retenSelect: 0.0,
    totalapagar: 0.0,
  });

  const [valuess, setValuess] = useState({
    idagente: "",
    nombre: "",
    rif: "",
    direccion: "",
  });

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const onChange = (e) => {
    setValuess({ ...valuess, [e.target.name]: e.target.value });
  };

  const SelectDeudaAgenProd = (id) => {
    setActivate(true);

    let tbl = props.tipo && props.tipo;
    let tab = "";
    let tipod = "";

    switch (tbl) {
      case "produccion":
        tab = "configproduccion";
        tipod = "(tipodeuda = 2 or tipodeuda=22 or tipodeuda=222)";
        break;
      case "minas":
        tab = "configminas";
        tipod = "(tipodeuda = 1 or tipodeuda=11 or tipodeuda=111)";
        break;
      case "guia":
        tab = "configminas";
        tipod = "(tipodeuda = 5 or tipodeuda=55)";
        break;
      case "1x500":
        tab = "config1x500";
        tipod = "(tipodeuda = 3 or tipodeuda=33 or tipodeuda=333)";
        break;
      case "expendedores":
        tab = "configexpendedores";
        tipod = "(tipodeuda = 4 or tipodeuda=44 or tipodeuda=444)";
        break;
      case "rentas":
        tab = "configrentas";
        tipod = "(tipodeuda = 17)";
        break;

      default:
        break;
    }
    let endpoint = `${op.conexion}/api/minas/deudas?idagente=${id}&fecha=${fechaSistema}&tabconf=${tab}&condic=${tipod}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let deu = [];
          let mul = [];
          let tas = [];
          let dism = 0;
          let dist = 0;
          let disd = 0;
          let totdeu = 0.0;
          let credit = 0.0;

          for (let i = 0; i < response.data.length; i++) {
            if (
              response.data[i].estatusfac === null ||
              response.data[i].estatusfac === 0
            ) {
              if (
                response.data[i].tipodeu === 11 ||
                response.data[i].tipodeu === 22 ||
                response.data[i].tipodeu === 33 ||
                response.data[i].tipodeu === 44
              ) {
                mul.push({
                  anio: response.data[i].anio,
                  mes: response.data[i].mes.replace("'", "").replace("'", ""),
                  monto: response.data[i].mondeu,
                  intereses: response.data[i].intmoradeu,
                  recargo: response.data[i].recargodeu,
                  multa: response.data[i].multa,
                  retenciones: response.data[i].retencion,
                  credito: response.data[i].acreditacion,
                  totalperi: response.data[i].subtotal,
                  status: response.data[i].estatus,
                  idfac: response.data[i].idfact,
                  nummes: response.data[i].nmes,
                  estatusfac: response.data[i].estatusfac,
                  tipotransaccion: response.data[i].tipotransaccion,
                  tipodeuda: response.data[i].tipodeu,
                  iddeu: response.data[i].iddeu,
                  perio: response.data[i].perio,
                  tipod: response.data[i].tipod,
                  concepto: response.data[i].txtconcepto,
                });

                if (response.data[i].fechapago === null) {
                  dism += 1;
                }
              } else if (
                response.data[i].tipodeu === 111 ||
                response.data[i].tipodeu === 222 ||
                response.data[i].tipodeu === 333 ||
                response.data[i].tipodeu === 444
              ) {
                tas.push({
                  anio: response.data[i].anio,
                  mes: response.data[i].mes.replace("'", "").replace("'", ""),
                  monto: response.data[i].mondeu,
                  intereses: response.data[i].intmoradeu,
                  recargo: response.data[i].recargodeu,
                  multa: response.data[i].multa,
                  retenciones: response.data[i].retencion,
                  credito: response.data[i].acreditacion,
                  totalperi: response.data[i].subtotal,
                  status: response.data[i].estatus,
                  idfac: response.data[i].idfact,
                  nummes: response.data[i].nmes,
                  estatusfac: response.data[i].estatusfac,
                  tipotransaccion: response.data[i].tipotransaccion,
                  tipodeuda: response.data[i].tipodeu,
                  iddeu: response.data[i].iddeu,
                  perio: response.data[i].perio,
                  tipod: response.data[i].tipod,
                  concepto: response.data[i].txtconcepto,
                });

                if (response.data[i].fechapago === null) {
                  dist += 1;
                }
              } else {
                if (parseFloat(response.data[i].mondeu) >= 0.0) {
                  deu.push({
                    anio: response.data[i].anio,
                    mes: response.data[i].mes.replace("'", "").replace("'", ""),
                    monto: response.data[i].mondeu,
                    intereses: response.data[i].intmoradeu,
                    recargo: response.data[i].recargodeu,
                    multa: response.data[i].multa,
                    retenciones: response.data[i].retencion,
                    credito: response.data[i].acreditacion,
                    totalperi: response.data[i].subtotal,
                    status: response.data[i].estatus,
                    idfac: response.data[i].idfact,
                    nummes: response.data[i].nmes,
                    estatusfac: response.data[i].estatusfac,
                    tipotransaccion: response.data[i].tipotransaccion,
                    tipodeuda: response.data[i].tipodeu,
                    iddeu: response.data[i].iddeu,
                    tipod: response.data[i].tipod,
                    concepto: response.data[i].txtconcepto,
                  });
                  if (response.data[i].fechapago === null) {
                    disd += 1;
                  }
                }
              }
              credit = parseFloat(response.data[i].acreditacion);
              totdeu =
                totdeu +
                parseFloat(response.data[i].mondeu) +
                parseFloat(response.data[i].intmoradeu) +
                parseFloat(response.data[i].recargodeu) +
                parseFloat(response.data[i].multa);
            }
          }

          setDeuda(deu);
          setMulta(mul);
          setTasa(tas);
          setDisponiblesMulta(dism);
          setDisponiblesTasa(dist);
          setDisponiblesDeuda(disd);
          setTotalSelect({
            concepto: "",
            seleccionados: 0,
            montoseleccionado: 0.0,
            acrediSelect: credit,
            montoFacturadoSelect: 0.0,
            interesesSelect: 0.0,
            multaSelect: 0.0,
            recargoSelect: 0.0,
            retenSelect: 0.0,
            totalapagar: 0.0,
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const procesarFactura = (body) => {
    let endpoint = `${op.conexion}/api/Caja_Ingreso/crearfactura`;
    setActivate(true);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        setActivate(false);
        if (response.status == 200) {
          valuess.idagente = "";
          valuess.rif = "";
          valuess.nombre = "";
          valuess.direccion = "";
          props.onHideAcepta();
          blanquear();
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const procesarencero = (body) => {
    let endpoint = `${op.conexion}/api/Caja_Ingreso/crearfacturacero`;
    setActivate(true);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.txtfactura !== null) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "Estimado contribuyente, hacemos de su conocimiento que el procedimiento fue exitoso.",
              icono: "exito",
            });
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Error",
              texto: "El pago no pudo ser Registrado.",
              icono: "error",
            });
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const chandleCheckDeuda = (item, index) => (e) => {
    e.preventDefault();
    let deu = [...deuda];
    let montoseleccionado = totalSelect.montoseleccionado;
    let montoFacturadoSelect = totalSelect.montoFacturadoSelect;
    let interesesSelect = totalSelect.interesesSelect;
    let multaSelect = totalSelect.multaSelect;
    let recargoSelect = totalSelect.recargoSelect;
    let retenSelect = totalSelect.retenSelect;
    let acrediSelect = totalSelect.acrediSelect;
    let per =
      totalSelect.concepto === ""
        ? "Periodo(s) de Pago: "
        : totalSelect.concepto;
    let periodofac = "";
    let seleccionados = totalSelect.seleccionados;
    let n = 0,
      pos = 0,
      poschk = -1;
    let continua = true;

    //  if (tabla.tabla !== "1x500") {
    for (let i = 0; i < chkSeleccionarDeuda.current.length; i++) {
      if (
        chkSeleccionarDeuda.current[i] !== null &&
        chkSeleccionarDeuda.current[i].checked === true
      ) {
        pos = i;
        n = n + 1;
        if ((pos > poschk) & (poschk > -1)) {
          continua = false;

          n = 0;
          pos = -1;
          poschk = 0;
          if (n === 0) {
            chkSeleccionarDeuda.current[index].checked = false;
          }
        }
      } else if (
        chkSeleccionarDeuda.current[i] !== null &&
        chkSeleccionarDeuda.current[i].checked === false
      ) {
        poschk = i;
      }
    }
    //  }
    if (continua) {
      if (item.anio !== anioActu) {
        setDisabledAnio(true);
      } else {
        setDisabledAnio2(true);
      }

      if (item.status === "Por Pagar") {
        per = per + item.mes + " / " + item.anio + " ";
        seleccionados = seleccionados + 1;
        periodofac = periodofac + item.nummes + " / " + item.anio + " ";
        montoseleccionado = montoseleccionado + parseFloat(item.totalperi);
        montoFacturadoSelect = montoFacturadoSelect + parseFloat(item.monto);
        interesesSelect = interesesSelect + parseFloat(item.intereses);
        multaSelect = multaSelect + parseFloat(item.multa);
        recargoSelect = recargoSelect + parseFloat(item.recargo);
        retenSelect = retenSelect + parseFloat(item.retenciones);
      } else {
        per = per.replace(item.mes + " / " + item.anio + " ", "");
        seleccionados = seleccionados - 1;
        periodofac = periodofac.replace(
          item.nummes + " / " + item.anio + " ",
          ""
        );
        montoseleccionado = montoseleccionado - parseFloat(item.totalperi);
        montoFacturadoSelect = montoFacturadoSelect - parseFloat(item.monto);
        interesesSelect = interesesSelect - parseFloat(item.intereses);
        multaSelect = multaSelect - parseFloat(item.multa);
        recargoSelect = recargoSelect - parseFloat(item.recargo);
        retenSelect = retenSelect - parseFloat(item.retenciones);
      }

      if (item.status === "Por Pagar") {
        item.status = "listo";
        setDisponiblesDeuda(disponiblesDeuda - 1);
      } else if (item.status === "listo") {
        item.status = "Por Pagar";
        setDisponiblesDeuda(disponiblesDeuda + 1);
      }

      deu[index] = item;

      setDeuda(deu);

      let apagar = montoseleccionado - acrediSelect - retenSelect;

      if (apagar < 0.0) {
        apagar = 0.0;
      }

      setTotalSelect({
        concepto: per,
        seleccionados: seleccionados,
        montoseleccionado: montoseleccionado,
        acrediSelect: acrediSelect,
        montoFacturadoSelect: montoFacturadoSelect,
        interesesSelect: interesesSelect,
        multaSelect: multaSelect,
        recargoSelect: recargoSelect,
        retenSelect: retenSelect,
        totalapagar: apagar,
      });

      if (seleccionados > 0) {
        setBtnDisabled(false);
        setDisabledMulta(true);
        setDisabledTasa(true);
      } else {
        setBtnDisabled(true);
        setDisabledMulta(false);
        setDisabledTasa(false);
        setDisabledAnio(false);
        setDisabledAnio2(false);
        setTotalSelect({
          concepto: "",
          seleccionados: 0,
          montoseleccionado: 0.0,
          acrediSelect: acrediSelect,
          montoFacturadoSelect: 0.0,
          interesesSelect: 0.0,
          multaSelect: 0.0,
          recargoSelect: 0.0,
          retenSelect: 0.0,
          totalapagar: 0.0,
        });
      }
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Posee deuda anterior al periodo seleccionado.",
        icono: "error",
      });
    }
  };

  const chandleCheckMulta = (item, index) => (e) => {
    e.preventDefault();

    let deu = [...multa];
    let montoseleccionado = totalSelect.montoseleccionado;
    let montoFacturadoSelect = totalSelect.montoFacturadoSelect;
    let interesesSelect = totalSelect.interesesSelect;
    let multaSelect = totalSelect.multaSelect;
    let recargoSelect = totalSelect.recargoSelect;
    let retenSelect = totalSelect.retenSelect;
    let acrediSelect = totalSelect.acrediSelect;
    let per =
      totalSelect.concepto === "" ? "Pago Multa(s): " : totalSelect.concepto;
    let periodofac = "";
    let seleccionados = totalSelect.seleccionados;

    if (item.status === "Por Pagar") {
      per = per + item.mes + " / " + item.anio + " ";
      seleccionados = seleccionados + 1;
      periodofac = periodofac + item.nummes + " / " + item.anio + " ";
      montoseleccionado = montoseleccionado + parseFloat(item.totalperi);
      montoFacturadoSelect = montoFacturadoSelect + parseFloat(item.monto);
      interesesSelect = interesesSelect + parseFloat(item.intereses);
      multaSelect = multaSelect + parseFloat(item.multa);
      recargoSelect = recargoSelect + parseFloat(item.recargo);
      retenSelect = retenSelect + parseFloat(item.retenciones);
    } else {
      per = per.replace(item.mes + " / " + item.anio + " ", "");
      seleccionados = seleccionados - 1;
      periodofac = periodofac.replace(
        item.nummes + " / " + item.anio + " ",
        ""
      );
      montoseleccionado = montoseleccionado - parseFloat(item.totalperi);
      montoFacturadoSelect = montoFacturadoSelect - parseFloat(item.monto);
      interesesSelect = interesesSelect - parseFloat(item.intereses);
      multaSelect = multaSelect - parseFloat(item.multa);
      recargoSelect = recargoSelect - parseFloat(item.recargo);
      retenSelect = retenSelect - parseFloat(item.retenciones);
    }

    if (item.status === "Por Pagar") {
      item.status = "listo";
      setDisponiblesMulta(disponiblesMulta - 1);
    } else if (item.status === "listo") {
      item.status = "Por Pagar";
      setDisponiblesMulta(disponiblesMulta + 1);
    }

    deu[index] = item;
    setMulta(deu);

    let apagar = montoseleccionado - acrediSelect - retenSelect;

    if (apagar < 0.0) {
      apagar = 0.0;
    }

    setTotalSelect({
      concepto: per,
      seleccionados: seleccionados,
      montoseleccionado: montoseleccionado,
      acrediSelect: acrediSelect,
      montoFacturadoSelect: montoFacturadoSelect,
      interesesSelect: interesesSelect,
      multaSelect: multaSelect,
      recargoSelect: recargoSelect,
      retenSelect: retenSelect,
      totalapagar: apagar,
    });

    if (seleccionados > 0) {
      setBtnDisabled(false);
      setDisabledDeuda(true);
      setDisabledTasa(true);
    } else {
      setBtnDisabled(true);
      setDisabledDeuda(false);
      setDisabledTasa(false);
      setTotalSelect({
        concepto: "",
        seleccionados: 0,
        montoseleccionado: 0.0,
        acrediSelect: acrediSelect,
        montoFacturadoSelect: 0.0,
        interesesSelect: 0.0,
        multaSelect: 0.0,
        recargoSelect: 0.0,
        retenSelect: 0.0,
        totalapagar: 0.0,
      });
    }
  };

  const chandleCheckTasa = (item, index) => (e) => {
    e.preventDefault();

    let deu = [...tasa];
    let montoseleccionado = totalSelect.montoseleccionado;
    let montoFacturadoSelect = totalSelect.montoFacturadoSelect;
    let interesesSelect = totalSelect.interesesSelect;
    let multaSelect = totalSelect.multaSelect;
    let recargoSelect = totalSelect.recargoSelect;
    let retenSelect = totalSelect.retenSelect;
    let acrediSelect = totalSelect.acrediSelect;
    let per =
      totalSelect.concepto === "" ? "Pago Tasa(s): " : totalSelect.concepto;
    let periodofac = "";
    let seleccionados = totalSelect.seleccionados;

    if (item.status === "Por Pagar") {
      per = per + item.mes + " / " + item.anio + " ";
      seleccionados = seleccionados + 1;
      periodofac = periodofac + item.nummes + " / " + item.anio + " ";
      montoseleccionado = montoseleccionado + parseFloat(item.totalperi);
      montoFacturadoSelect = montoFacturadoSelect + parseFloat(item.monto);
      interesesSelect = interesesSelect + parseFloat(item.intereses);
      multaSelect = multaSelect + parseFloat(item.multa);
      recargoSelect = recargoSelect + parseFloat(item.recargo);
      retenSelect = retenSelect + parseFloat(item.retenciones);
    } else {
      per = per.replace(item.mes + " / " + item.anio + " ", "");
      seleccionados = seleccionados - 1;
      periodofac = periodofac.replace(
        item.nummes + " / " + item.anio + " ",
        ""
      );
      montoseleccionado = montoseleccionado - parseFloat(item.totalperi);
      montoFacturadoSelect = montoFacturadoSelect - parseFloat(item.monto);
      interesesSelect = interesesSelect - parseFloat(item.intereses);
      multaSelect = multaSelect - parseFloat(item.multa);
      recargoSelect = recargoSelect - parseFloat(item.recargo);
      retenSelect = retenSelect - parseFloat(item.retenciones);
    }

    if (item.status === "Por Pagar") {
      item.status = "listo";
      setDisponiblesTasa(disponiblesTasa - 1);
    } else if (item.status === "listo") {
      item.status = "Por Pagar";
      setDisponiblesTasa(disponiblesTasa + 1);
    }

    deu[index] = item;
    setTasa(deu);

    let apagar = montoseleccionado - acrediSelect - retenSelect;

    if (apagar < 0.0) {
      apagar = 0.0;
    }

    setTotalSelect({
      concepto: per,
      seleccionados: seleccionados,
      montoseleccionado: montoseleccionado,
      acrediSelect: acrediSelect,
      montoFacturadoSelect: montoFacturadoSelect,
      interesesSelect: interesesSelect,
      multaSelect: multaSelect,
      recargoSelect: recargoSelect,
      retenSelect: retenSelect,
      totalapagar: apagar,
    });

    if (seleccionados > 0) {
      setBtnDisabled(false);
      setDisabledDeuda(true);
      setDisabledMulta(true);
    } else {
      setBtnDisabled(true);
      setDisabledDeuda(false);
      setDisabledMulta(false);
      setTotalSelect({
        concepto: "",
        seleccionados: 0,
        montoseleccionado: 0.0,
        acrediSelect: acrediSelect,
        montoFacturadoSelect: 0.0,
        interesesSelect: 0.0,
        multaSelect: 0.0,
        recargoSelect: 0.0,
        retenSelect: 0.0,
        totalapagar: 0.0,
      });
    }
  };

  const procesarPagoWebCero = () => {
    let nAnio = [];
    let nMes = [];
    let nMonto = [];
    let nInteres = [];
    let nMulta = [];
    let nRecargo = [];
    let nTotal = [];
    let cIdFact = [];
    let cNumPlani = [];
    let cPeri = [];
    let tdeu = [];
    let iddeu = [];
    let tipod = [];
    let tpingreso = 0;
    let anioDeu = parseInt(0);

    if (disabledMulta && disabledTasa) {
      for (let i = 0; i < deuda.length; i++) {
        if (deuda[i].status === "listo") {
          anioDeu = deuda[i].anio;
          nAnio.push(deuda[i].anio);
          nMes.push(deuda[i].nummes);
          nMonto.push(deuda[i].monto);
          nInteres.push(deuda[i].intereses);
          nMulta.push(deuda[i].multa);
          nRecargo.push(deuda[i].recargo);
          nTotal.push(deuda[i].totalperi);
          cIdFact.push(deuda[i].idfact);
          cNumPlani.push(deuda[i].planilla);
          cPeri.push(deuda[i].periodo);
          tdeu.push(deuda[i].tipodeuda);
          iddeu.push(parseInt(deuda[i].iddeu));
          tipod.push(deuda[i].tipod);
        }
      }

      if (props.tipo === "minas") {
        tpingreso = anioDeu < anioActu ? 14 : 1;
      } else if (props.tipo === "produccion") {
        tpingreso = anioDeu < anioActu ? 15 : 2;
      } else if (props.tipo === "1x500") {
        tpingreso = anioDeu < anioActu ? 16 : 3;
      }
    } else if (disabledDeuda && disabledMulta) {
      tpingreso = 19;

      for (let i = 0; i < tasa.length; i++) {
        if (tasa[i].status === "listo") {
          nAnio.push(tasa[i].anio);
          nMes.push(tasa[i].nummes);
          nMonto.push(tasa[i].monto);
          nInteres.push(tasa[i].intereses);
          nMulta.push(tasa[i].multa);
          nRecargo.push(tasa[i].recargo);
          nTotal.push(tasa[i].totalperi);
          cIdFact.push(tasa[i].idfact);
          cNumPlani.push(tasa[i].planilla);
          cPeri.push(tasa[i].periodo);
          tdeu.push(tasa[i].tipodeuda);
          iddeu.push(parseInt(tasa[i].iddeu));
          tipod.push(tasa[i].tipod);
        }
      }
    } else if (disabledDeuda && disabledTasa) {
      if (props.tipo === "minas") {
        tpingreso = 9;
      } else if (props.tipo === "produccion") {
        tpingreso = 10;
      } else if (props.tipo === "1x500") {
        tpingreso = 11;
      }

      for (let i = 0; i < multa.length; i++) {
        if (multa[i].status === "listo") {
          nAnio.push(multa[i].anio);
          nMes.push(multa[i].nummes);
          nMonto.push(multa[i].monto);
          nInteres.push(multa[i].intereses);
          nMulta.push(multa[i].multa);
          nRecargo.push(multa[i].recargo);
          nTotal.push(multa[i].totalperi);
          cIdFact.push(multa[i].idfact);
          cNumPlani.push(multa[i].planilla);
          cPeri.push(multa[i].periodo);
          tdeu.push(multa[i].tipodeuda);
          iddeu.push(parseInt(multa[i].iddeu));
          tipod.push(multa[i].tipod);
        }
      }
    }

    let body = {
      txtidagente: txtAgente.current.value,
      txtmonto: totalSelect.montoFacturadoSelect,
      txtmulta: totalSelect.multaSelect,
      txtinteres: totalSelect.interesesSelect,
      txtrecargo: totalSelect.recargoSelect,
      txtcredito: totalSelect.acrediSelect,
      txtconcepto: totalSelect.concepto,
      fechasis: fechaSistema,
      idimpu: tpingreso,
      panio: nAnio,
      pmes: nMes,
      pmonto: nMonto,
      pinteres: nInteres,
      pmulta: nMulta,
      precargo: nRecargo,
      ptotal: nTotal,
      tdeu,
      iddeu,
      tipod,
    };

    procesarencero(body);
  };

  const procesar = () => {
    setMensajesino({
      mostrar: true,
      titulo: "Confirmación.",
      texto: "Esta Seguro de Crear la Factura?",
      icono: "confirmacion",
    });
  };

  const handleCloseSi = () => {
    if (totalSelect.totalapagar === 0.0) {
      procesarPagoWebCero();
    } else {
      onChangeValidar();
    }
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const blanquear = () => {
    setMulta([]);
    setTasa([]);
    setDeuda([]);
    setDisponiblesMulta(0);
    setDisponiblesTasa(0);
    setDisponiblesDeuda(0);
    setBtnDisabled(true);
    setDisabledMulta(false);
    setDisabledTasa(false);
    setDisabledDeuda(false);
    setDisabledAnio(false);
    setDisabledAnio2(false);
    setTotalSelect({
      concepto: "",
      seleccionados: 0,
      montoseleccionado: 0.0,
      acrediSelect: 0.0,
      montoFacturadoSelect: 0.0,
      interesesSelect: 0.0,
      multaSelect: 0.0,
      recargoSelect: 0.0,
      retenSelect: 0.0,
      totalapagar: 0.0,
    });
  };

  const handleCatalogo = () => {
    if (!catalogo) {
      setCatalogo(true);
    } else {
      setCatalogo(false);
    }
  };

  const onHideAceptaCatAge = (idage, nombage, rif, direccion, status) => {
    setCatalogo(false);
    let tipo = props.tipo;
    let minas = "minas";
    let unosx500 = "1x500";
    let timbres = "expendedores";
    let pro = "produccion";
    if (tipo === minas) {
      if (status === "51") {
        setValuess({
          ...valuess,
          idagente: idage,
          nombre: nombage,
          rif: rif,
          direccion: direccion,
        });
        SelectDeudaAgenProd(idage);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "AGENTE INACTIVO, CONTACTE CON EL ADMINISTRADOR",
          icono: "error",
        });
        valuess.idagente = "";
        valuess.rif = "";
        valuess.nombre = "";
        valuess.direccion = "";
        blanquear();
      }
    } else if (tipo === unosx500) {
      if (status === "51") {
        setValuess({
          ...valuess,
          idagente: idage,
          nombre: nombage,
          rif: rif,
          direccion: direccion,
        });
        SelectDeudaAgenProd(idage);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "AGENTE INACTIVO, CONTACTE CON EL ADMINISTRADOR",
          icono: "error",
        });
        valuess.idagente = "";
        valuess.rif = "";
        valuess.nombre = "";
        valuess.direccion = "";
        blanquear();
      }
    } else if (tipo === timbres) {
      if (status === "51") {
        setValuess({
          ...valuess,
          idagente: idage,
          nombre: nombage,
          rif: rif,
          direccion: direccion,
        });
        SelectDeudaAgenProd(idage);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "AGENTE INACTIVO, CONTACTE CON EL ADMINISTRADOR",
          icono: "error",
        });
        valuess.idagente = "";
        valuess.rif = "";
        valuess.nombre = "";
        valuess.direccion = "";
        blanquear();
      }
    } else if (tipo === pro) {
      if (status === "51") {
        setValuess({
          ...valuess,
          idagente: idage,
          nombre: nombage,
          rif: rif,
          direccion: direccion,
        });
        SelectDeudaAgenProd(idage);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "AGENTE INACTIVO, CONTACTE CON EL ADMINISTRADOR",
          icono: "error",
        });
        valuess.idagente = "";
        valuess.rif = "";
        valuess.nombre = "";
        valuess.direccion = "";
        blanquear();
      }
    }
  };

  const datosAgente = (idagente) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";

    let endpoint = `${op.conexion}/api/retencion/seleccionaragente?&campos=${campos}&id=${idagente}&nomid=${nomid}&nomtab=${nomtab}&nomid2=${props.campo}&id2=${props.valor}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            if (props.tipo === "minas") {
              if (response.data.statusmina === "51") {
                txtAgente.current.value = response.data.idagente;
                valuess.rif = response.data.rif;
                valuess.nombre = response.data.nombre;
                valuess.direccion = response.data.direccion;
                SelectDeudaAgenProd(txtAgente.current.value);
              } else {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "AGENTE INACTIVO, CONTACTE CON EL ADMINISTRADOR",
                  icono: "error",
                });
                txtAgente.current.value = response.data.idagente;
                valuess.rif = "";
                valuess.nombre = "";
                valuess.direccion = "";
                blanquear();
              }
            } else if (props.tipo === "1x500") {
              if (response.data.status1x500 === "51") {
                txtAgente.current.value = response.data.idagente;
                valuess.rif = response.data.rif;
                valuess.nombre = response.data.nombre;
                valuess.direccion = response.data.direccion;
                SelectDeudaAgenProd(txtAgente.current.value);
              } else {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "AGENTE INACTIVO, CONTACTE CON EL ADMINISTRADOR",
                  icono: "error",
                });
                txtAgente.current.value = response.data.idagente;
                valuess.rif = "";
                valuess.nombre = "";
                valuess.direccion = "";
                blanquear();
              }
            } else if (props.tipo === "produccion") {
              if (response.data.statusproduccion === "51") {
                txtAgente.current.value = response.data.idagente;
                valuess.rif = response.data.rif;
                valuess.nombre = response.data.nombre;
                valuess.direccion = response.data.direccion;
                SelectDeudaAgenProd(txtAgente.current.value);
              } else {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "AGENTE INACTIVO, CONTACTE CON EL ADMINISTRADOR",
                  icono: "error",
                });
                txtAgente.current.value = response.data.idagente;
                valuess.rif = "";
                valuess.nombre = "";
                valuess.direccion = "";
                blanquear();
              }
            } else if (props.tipo === "expendedores") {
              if (response.data.statusexpe === "51") {
                txtAgente.current.value = response.data.idagente;
                valuess.rif = response.data.rif;
                valuess.nombre = response.data.nombre;
                valuess.direccion = response.data.direccion;
                SelectDeudaAgenProd(txtAgente.current.value);
              } else {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "AGENTE INACTIVO, CONTACTE CON EL ADMINISTRADOR",
                  icono: "error",
                });
                txtAgente.current.value = response.data.idagente;
                valuess.rif = "";
                valuess.nombre = "";
                valuess.direccion = "";
                blanquear();
              }
            }
          } else {
            if (teclas === 13) {
              setTimeout(() => {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "Código/Agente no Existe...",
                  icono: "error",
                });
                txtAgente.current.value = "";
                valuess.rif = "";
                valuess.nombre = "";
                valuess.direccion = "";
                blanquear();
                txtAgente.current.focus();
              }, 100);
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validarAgente = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTeclas(event.which);
        datosAgente(event.target.value);
      } else {
        txtAgente.current.value = "";
      }
    }
  };

  const cancelar = (e) => {
    e.preventDefault();
    valuess.idagente = "";
    valuess.rif = "";
    valuess.nombre = "";
    valuess.direccion = "";
    props.onHideCancela();
    blanquear();
  };

  const onChangeValidar = () => {
    let factu = [];
    let factudet = [];
    let idTipIngre = 0;
    let anioDeu = parseInt(0);
    let idDeu = parseInt(0);

    if (!disabledDeuda) {
      for (let i = 0; i < deuda.length; i++) {
        if (deuda[i].status === "listo") {
          anioDeu = deuda[i].anio;
          factudet.push({
            montoimpuesto: deuda[i].monto,
            montorecargo: deuda[i].recargo,
            montointeres: deuda[i].intereses,
            periodo: deuda[i].nummes + "/" + deuda[i].anio,
            montomulta: deuda[i].multa,
            iddeuda: deuda[i].iddeu,
          });
        }
      }
      if (props.tipo === "minas") {
        idTipIngre = anioDeu < anioActu ? 11 : 1;
      } else if (props.tipo === "produccion") {
        idTipIngre = anioDeu < anioActu ? 12 : 2;
      } else if (props.tipo === "1x500") {
        idTipIngre = anioDeu < anioActu ? 13 : 3;
      }
      factu.push({
        totalinmpuesto: totalSelect.montoFacturadoSelect,
        totalrecargo: totalSelect.recargoSelect,
        totalinteres: totalSelect.interesesSelect,
        idtipoingreso: idTipIngre,
        fechaemision: fechaSistema,
        descripcion: totalSelect.concepto,
        tablacontribuyente: props.tipo,
        tabladeuda: "deuda" || props.tipo,
        status: 0,
        nombrecontri: valuess.nombre,
        direccioncontri: valuess.direccion,
        cedrif: valuess.rif,
        totalmulta: totalSelect.multaSelect,
        deducible:
          parseFloat(totalSelect.retenSelect) +
          parseFloat(totalSelect.acrediSelect),
        facturador: idusuario,
        totalfactura: totalSelect.totalapagar,
      });
    } else if (!disabledMulta) {
      for (let i = 0; i < multa.length; i++) {
        if (multa[i].status === "listo") {
          factudet.push({
            montoimpuesto: multa[i].monto,
            montorecargo: multa[i].recargo,
            montointeres: multa[i].intereses,
            periodo: multa[i].nummes + "/" + multa[i].anio,
            montomulta: multa[i].multa,
            iddeuda: multa[i].iddeu,
          });
        }
      }

      if (props.tipo === "minas") {
        idTipIngre = 9;
      } else if (props.tipo === "produccion") {
        idTipIngre = 10;
      } else if (props.tipo === "1x500") {
        idTipIngre = 11;
      }

      factu.push({
        totalinmpuesto: totalSelect.montoFacturadoSelect,
        totalrecargo: totalSelect.recargoSelect,
        totalinteres: totalSelect.interesesSelect,
        idtipoingreso: idTipIngre,
        fechaemision: fechaSistema,
        descripcion: totalSelect.concepto,
        tablacontribuyente: props.tipo,
        tabladeuda: "deuda" || props.tipo,
        status: 0,
        nombrecontri: valuess.nombre,
        direccioncontri: valuess.direccion,
        cedrif: valuess.rif,
        totalmulta: totalSelect.multaSelect,
        deducible:
          parseFloat(totalSelect.retenSelect) +
          parseFloat(totalSelect.acrediSelect),
        facturador: idusuario,
        totalfactura: totalSelect.totalapagar,
      });
    } else if (!disabledTasa) {
      for (let i = 0; i < tasa.length; i++) {
        if (tasa[i].status === "listo") {
          factudet.push({
            montoimpuesto: tasa[i].monto,
            montorecargo: tasa[i].recargo,
            montointeres: tasa[i].intereses,
            periodo: tasa[i].nummes + "/" + tasa[i].anio,
            montomulta: tasa[i].multa,
            iddeuda: tasa[i].iddeu,
          });
        }
      }
      idTipIngre = 19;

      factu.push({
        totalinmpuesto: totalSelect.montoFacturadoSelect,
        totalrecargo: totalSelect.recargoSelect,
        totalinteres: totalSelect.interesesSelect,
        idtipoingreso: idTipIngre,
        fechaemision: fechaSistema,
        descripcion: totalSelect.concepto,
        tablacontribuyente: props.tipo,
        tabladeuda: "deuda" || props.tipo,
        status: 0,
        nombrecontri: valuess.nombre,
        direccioncontri: valuess.direccion,
        cedrif: valuess.rif,
        totalmulta: totalSelect.multaSelect,
        deducible:
          parseFloat(totalSelect.retenSelect) +
          parseFloat(totalSelect.acrediSelect),
        facturador: idusuario,
        totalfactura: totalSelect.totalapagar,
      });
    }

    let body = {
      idagen: parseInt(txtAgente.current.value, 10),
      factu: JSON.stringify(factu),
      factudet: JSON.stringify(factudet),
    };

    procesarFactura(body);
  };

  const cerrarModal = () => {
    blanquear();
    SelectDeudaAgenProd(txtAgente.current.value);
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {}}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3 className="text-capitalize">
            {props.tipo === "1x500" ? "1x1000" : props.tipo}
          </h3>
        </div>
        <button
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF", color: "" }}>
        <div
          className="titulos"
          style={{
            height: "auto",
            minHeight: "auto",
            maxHeight: "90vh",
            overflow: "auto",
          }}
        >
          <div className="container">
            <fieldset className="row border-azul rounded mx-auto">
              <legend className="float-none m-0 w-auto">
                Datos del Contribuyente
              </legend>
              <div className="col-md-12 row m-0">
                <div className="col-sm-2 col-12 px-1">
                  <div className="input-group input-group-sm">
                    <label
                      htmlFor="idagente"
                      className="form-label input-group-text"
                      id="validationTooltipAgente"
                      style={{ backgroundColor: "#55acee" }}
                    >
                      CÓDIGO:
                    </label>
                    <input
                      type="text"
                      name="idagente"
                      autoComplete="off"
                      ref={txtAgente}
                      value={valuess.idagente}
                      onKeyUp={validarAgente}
                      aria-describedby="validationTooltipAgente"
                      placeholder="Código"
                      className="form-control border"
                      onChange={onChange}
                    />
                    <button className="btn btn-info" onClick={handleCatalogo}>
                      <i className="fa fa-search"></i>
                    </button>
                  </div>
                </div>
                <div className="col-sm-7 col-12 px-2">
                  <div className="input-group input-group-sm px-5">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      NOMBRES:
                    </label>
                    <input
                      type="text"
                      disabled
                      className="form-control bg-light"
                      autoComplete="off"
                      aria-label="Sizing example input"
                      value={valuess.nombre}
                      aria-describedby="inputGroup-sizing-sm"
                      name="nombre"
                    />
                  </div>
                </div>
                <div className="col-sm-3 col-12 px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CÉDULA/RIF:
                    </label>
                    <input
                      type="text"
                      disabled
                      className="form-control bg-light"
                      autoComplete="off"
                      aria-label="Sizing example input"
                      value={valuess.rif}
                      aria-describedby="inputGroup-sizing-sm"
                      name="rif"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-12 row m-0 py-1">
                <div className="col-sm-12 col-12 px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      DIRECCIÓN:
                    </label>
                    <input
                      type="text"
                      disabled
                      className="form-control bg-light"
                      autoComplete="off"
                      aria-label="Sizing example input"
                      value={valuess.direccion}
                      aria-describedby="inputGroup-sizing-sm"
                      name="direccion"
                    />
                  </div>
                </div>
              </div>
            </fieldset>
            <div className="col-md-12 py-1"></div>
            <fieldset className="border-azul rounded row m-0">
              <legend className="float-none m-0 w-auto">
                Datos de la Deuda
              </legend>
              <div className="col-md-12 mx-auto">
                <Dimmer active={activate} />
                <div id="declaraciones">
                  <TblContainer
                    container={{
                      maxHeight: 180,
                      width: "100%",
                      overflow: "auto",
                    }}
                  >
                    <TblHead />
                    <TableBody>
                      {multa &&
                        multa.map((deu, index) => (
                          <TableRow key={index}>
                            {deu.status === "Por Pagar" ? (
                              <TableCell className="p-1 text-center letra-tabla-td">
                                <input
                                  type="checkbox"
                                  disabled={disabledMulta}
                                  ref={(el) =>
                                    (chkSeleccionarMulta.current[index] = el)
                                  }
                                  defaultChecked={
                                    deu.status === "Por Pagar" ? false : true
                                  }
                                  onClick={chandleCheckMulta(deu, index)}
                                  name={"chk" + deu.mes + deu.anio}
                                  style={{ width: 20, height: 20 }}
                                />
                              </TableCell>
                            ) : (
                              <TableCell className="p-1 text-center letra-tabla-td">
                                <input
                                  type="checkbox"
                                  ref={(el) =>
                                    (chkSeleccionarMulta.current[index] = el)
                                  }
                                  defaultChecked={true}
                                  name={"chk" + deu.mes + deu.anio}
                                  onClick={chandleCheckMulta(deu, index)}
                                  style={{
                                    width: 20,
                                    height: 20,
                                  }} /* disabled={(deu.status === 'listo' && (multa.length - disponiblesMulta) === index + 1) ? false : true}  */
                                />
                              </TableCell>
                            )}
                            <TableCell className="p-1 text-center letra-tabla-td fw-bold">
                              {"Multa"}
                            </TableCell>
                            <TableCell className="p-1 text-start letra-tabla-td">
                              {deu.concepto !== null ? deu.concepto.trim() : ""}
                            </TableCell>
                            <TableCell className="p-1 text-center letra-tabla-td">
                              {deu.anio}
                            </TableCell>
                            <TableCell className="p-1 text-center letra-tabla-td">
                              {deu.mes}
                            </TableCell>
                            <TableCell className="p-1 text-end letra-tabla-td">
                              {formatMoneda(
                                deu.monto.replace(",", "").replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell className="p-1 text-end letra-tabla-td">
                              {formatMoneda(
                                deu.intereses
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell className="p-1 text-end letra-tabla-td">
                              {formatMoneda(
                                deu.recargo.replace(",", "").replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell className="p-1 text-end letra-tabla-td">
                              {formatMoneda(
                                deu.multa.replace(",", "").replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell className="p-1 text-end letra-tabla-td">
                              {formatMoneda(
                                deu.totalperi
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell className="p-1 text-center letra-tabla-td">
                              {deu.status === "Por Pagar" ? (
                                <i className="fas text-danger fa-exclamation-triangle">
                                  {" "}
                                  {deu.status}
                                </i>
                              ) : (
                                <i className="fas text-success fa-check-double"></i>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      {tasa &&
                        tasa.map((deu, index) => (
                          <TableRow key={index}>
                            {deu.status === "Por Pagar" ? (
                              <TableCell className="p-0 text-center letra-tabla-td">
                                <input
                                  type="checkbox"
                                  disabled={disabledTasa}
                                  ref={(el) =>
                                    (chkSeleccionarTasa.current[index] = el)
                                  }
                                  defaultChecked={
                                    deu.status === "Por Pagar" ? false : true
                                  }
                                  onClick={chandleCheckTasa(deu, index)}
                                  name={"chk" + deu.mes + deu.anio}
                                  style={{ width: 20, height: 20 }}
                                />
                              </TableCell>
                            ) : (
                              <TableCell className="p-0 text-center letra-tabla-td">
                                <input
                                  type="checkbox"
                                  ref={(el) =>
                                    (chkSeleccionarTasa.current[index] = el)
                                  }
                                  defaultChecked={true}
                                  name={
                                    "chk" + deu.mes + deu.anio + +deu.iddeuda
                                  }
                                  onClick={chandleCheckTasa(deu, index)}
                                  style={{
                                    width: 20,
                                    height: 20,
                                  }} /* disabled={(deu.status === 'listo' && (multa.length - disponiblesMulta) === index + 1) ? false : true}  */
                                />
                              </TableCell>
                            )}
                            <TableCell className="p-0 text-center letra-tabla-td fw-bold">
                              {"Tasa"}
                            </TableCell>
                            <TableCell className="p-1 text-start letra-tabla-td">
                              {deu.concepto !== null ? deu.concepto.trim() : ""}
                            </TableCell>
                            <TableCell className="p-0 text-center letra-tabla-td">
                              {deu.anio}
                            </TableCell>
                            <TableCell className="p-0 text-center letra-tabla-td">
                              {deu.mes}
                            </TableCell>
                            <TableCell className="p-0 text-end letra-tabla-td">
                              {formatMoneda(
                                deu.monto.replace(",", "").replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell className="p-0 text-end letra-tabla-td">
                              {formatMoneda(
                                deu.intereses
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell className="p-0 text-end letra-tabla-td">
                              {formatMoneda(
                                deu.multa.replace(",", "").replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell className="p-0 text-end letra-tabla-td">
                              {formatMoneda(
                                deu.recargo.replace(",", "").replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell className="p-0 text-end letra-tabla-td">
                              {formatMoneda(
                                deu.totalperi
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell className="p-0 text-center letra-tabla-td">
                              {deu.status === "Por Pagar" ? (
                                <i className="fas text-danger fa-exclamation-triangle">
                                  {" "}
                                  {deu.status}
                                </i>
                              ) : (
                                <i className="fas text-success fa-check-double"></i>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      {deuda &&
                        deuda.map((deu, index) => (
                          <TableRow key={index}>
                            {deu.status === "Por Pagar" ? (
                              <TableCell className="p-1 text-center letra-tabla-td">
                                <input
                                  type="checkbox"
                                  disabled={
                                    props.tipo === "1x500" &&
                                    deuda.length !== disponiblesDeuda
                                      ? true
                                      : deu.anio === anioActu
                                      ? disabledAnio
                                      : disabledAnio2
                                      ? true
                                      : disabledDeuda
                                  }
                                  ref={(el) =>
                                    (chkSeleccionarDeuda.current[index] = el)
                                  }
                                  defaultChecked={
                                    deu.status === "Por Pagar" ? false : true
                                  }
                                  onClick={chandleCheckDeuda(deu, index)}
                                  name={"chk" + deu.mes + deu.anio}
                                  style={{ width: 20, height: 20 }}
                                />
                              </TableCell>
                            ) : (
                              <TableCell className="p-1 text-center letra-tabla-td">
                                <input
                                  type="checkbox"
                                  ref={(el) =>
                                    (chkSeleccionarDeuda.current[index] = el)
                                  }
                                  defaultChecked={true}
                                  name={"chk" + deu.mes + deu.anio}
                                  onClick={chandleCheckDeuda(deu, index)}
                                  style={{
                                    width: 20,
                                    height: 20,
                                  }} /* disabled={( deu.status === 'listo' && ((tabla && tabla.tabla==='1x500') || ((deuda.length - disponiblesDeuda) === index + 1))) ? false : true} */
                                />
                              </TableCell>
                            )}
                            <TableCell className="p-1 text-center letra-tabla-td fw-bold">
                              {"Deuda"}
                            </TableCell>
                            <TableCell className="p-1 text-start letra-tabla-td">
                              {deu.concepto !== null ? deu.concepto.trim() : ""}
                            </TableCell>
                            <TableCell className="p-1 text-center letra-tabla-td">
                              {deu.anio}
                            </TableCell>
                            <TableCell className="p-1 text-center letra-tabla-td">
                              {deu.mes}
                            </TableCell>
                            <TableCell className="p-1 text-end letra-tabla-td">
                              {formatMoneda(
                                deu.monto.replace(",", "").replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell className="p-1 text-end letra-tabla-td">
                              {formatMoneda(
                                deu.intereses
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell className="p-1 text-end letra-tabla-td">
                              {formatMoneda(
                                deu.recargo.replace(",", "").replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell className="p-1 text-end letra-tabla-td">
                              {formatMoneda(
                                deu.multa.replace(",", "").replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell className="p-1 text-end letra-tabla-td">
                              {formatMoneda(
                                deu.totalperi
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell className="p-1 text-center letra-tabla-td">
                              {deu.status === "Por Pagar" ? (
                                <i className="fas text-danger fa-exclamation-triangle">
                                  {" "}
                                  {deu.status}
                                </i>
                              ) : (
                                <i className="fas text-success fa-check-double"></i>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </TblContainer>
                  <div
                    className="row col-12 p-0 m-0 border-table"
                    style={{ borderTopStyle: "hidden" }}
                  >
                    <table>
                      <tbody>
                        <tr>
                          <td className="p-0 text-end">
                            <p
                              style={{
                                fontFamily: "Times New Roman, Times, serif",
                                fontWeight: "bold",
                                fontSize: 14,
                                margin: 0,
                              }}
                            >
                              Monto:{" "}
                              {formatMoneda(
                                totalSelect.montoFacturadoSelect
                                  .toString()
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </p>
                          </td>
                          <td className="p-0 text-end">
                            <p
                              style={{
                                fontFamily: "Times New Roman, Times, serif",
                                fontWeight: "bold",
                                fontSize: 14,
                                margin: 0,
                              }}
                            >
                              Interes:{" "}
                              {formatMoneda(
                                totalSelect.interesesSelect
                                  .toString()
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </p>
                          </td>
                          <td className="p-0 text-end">
                            <p
                              style={{
                                fontFamily: "Times New Roman, Times, serif",
                                fontWeight: "bold",
                                fontSize: 14,
                                margin: 0,
                              }}
                            >
                              Multa:{" "}
                              {formatMoneda(
                                totalSelect.multaSelect
                                  .toString()
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </p>
                          </td>
                          <td className="p-0 text-end">
                            <p
                              style={{
                                fontFamily: "Times New Roman, Times, serif",
                                fontWeight: "bold",
                                fontSize: 14,
                                margin: 0,
                              }}
                            >
                              Recargo:{" "}
                              {formatMoneda(
                                totalSelect.recargoSelect
                                  .toString()
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </p>
                          </td>
                          <td className="p-0 text-end">
                            <p
                              style={{
                                fontFamily: "Times New Roman, Times, serif",
                                fontWeight: "bold",
                                fontSize: 14,
                                margin: 0,
                              }}
                            >
                              Retenciones:{" "}
                              {formatMoneda(
                                totalSelect.retenSelect
                                  .toString()
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </p>
                          </td>
                          <td className="p-0 text-end">
                            <p
                              style={{
                                fontFamily: "Times New Roman, Times, serif",
                                fontWeight: "bold",
                                fontSize: 14,
                                margin: 0,
                                paddingRight: 5,
                              }}
                            >
                              Total:{" "}
                              {formatMoneda(
                                totalSelect.montoseleccionado
                                  .toString()
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div
                  className="row col-12 p-0 m-0 border-table"
                  style={{ borderTopStyle: "hidden" }}
                >
                  <div className="col-md-10">
                    <div className="input-group">
                      <p
                        style={{
                          fontFamily: "Times New Roman, Times, serif",
                          fontWeight: "bold",
                          fontSize: 14,
                          margin: 0,
                        }}
                      >
                        Concepto:
                      </p>{" "}
                      &nbsp;{" "}
                      <p
                        style={{
                          fontFamily: "Arial, Helvetica, sans-serif",
                          fontSize: 14,
                          margin: 0,
                        }}
                      >
                        {totalSelect.concepto}
                      </p>
                    </div>
                    <div className="input-group">
                      <p
                        style={{
                          fontFamily: "Times New Roman, Times, serif",
                          fontWeight: "bold",
                          fontSize: 14,
                          margin: 0,
                        }}
                      >
                        Seleccionados:
                      </p>{" "}
                      &nbsp;{" "}
                      <p
                        style={{
                          fontFamily: "Arial, Helvetica, sans-serif",
                          fontSize: 14,
                          margin: 0,
                        }}
                      >
                        {totalSelect.seleccionados}
                      </p>
                    </div>
                    <div className="input-group">
                      <p
                        style={{
                          fontFamily: "Times New Roman, Times, serif",
                          fontWeight: "bold",
                          fontSize: 14,
                          margin: 0,
                        }}
                      >
                        Credito Fiscal:
                      </p>{" "}
                      &nbsp;{" "}
                      <p
                        style={{
                          fontFamily: "Arial, Helvetica, sans-serif",
                          fontSize: 14,
                          margin: 0,
                        }}
                      >
                        {formatMoneda(
                          totalSelect.acrediSelect.toString().replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </p>
                    </div>
                    <div className="input-group">
                      <p
                        style={{
                          fontFamily: "Times New Roman, Times, serif",
                          fontWeight: "bold",
                          fontSize: 14,
                          margin: 0,
                        }}
                      >
                        Total:
                      </p>{" "}
                      &nbsp;{" "}
                      <p
                        style={{
                          fontFamily: "Arial, Helvetica, sans-serif",
                          fontSize: 14,
                          margin: 0,
                        }}
                      >
                        {formatMoneda(
                          totalSelect.totalapagar.toString().replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          disabled={btnDisabled}
          onClick={procesar}
          className="btn btn-sm rounded-pill btn-success col-md-2"
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <CatalogoAgenteTipo2
        show={catalogo}
        campoclave={props.campo}
        valorclave={props.valor}
        onHideCancelaCatAge={handleCatalogo}
        onHideAceptaCatAge={onHideAceptaCatAge}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/ingresos/modalMinaCaja.js